import { arrayUtils } from "cayo.ui";
import {
  ConditionType,
  IAnrCondition,
  IMaxResultsCondition,
  IModernFilterCondition,
  IQuery,
  QueryRequestProps,
  ISearchResult,
} from "@cayo/shared/components/GridContainer/types";
import { isDate, isString } from "@cayo/shared/types/typeGuards";
import { ItemsStore } from "./ItemsStore";
import ajax from "@cayo/shared/libs/ajax";

const { getClient } = ajax;

type ODataParameter = { name: string; value: string };

export class AdminItemsStore extends ItemsStore {
  constructor(itemsUrl: string, pageSize: number = 100) {
    super(itemsUrl, pageSize);
  }

  public async execute(
    query: IQuery,
    effectiveFilter: string,
    columns: string[],
    nextPageToken?: string | null,
    top?: number,
    props?: QueryRequestProps
  ): Promise<ISearchResult> {
    const searchText = (
      query?.conditions?.find((c) => c.kind === ConditionType.Anr) as IAnrCondition
    )?.value;

    const maxResults =
      (query?.conditions?.find((c) => c.kind === ConditionType.MaxResults) as IMaxResultsCondition)
        ?.value ?? "20";

    const filterItems =
      (
        query?.conditions?.find(
          (c) => c.kind === ConditionType.ModernFilter
        ) as IModernFilterCondition
      )?.value ?? [];

    const body: { parameters: ODataParameter[] } = { parameters: [] };
    if (searchText) {
      body.parameters.push({ name: "CayoQuickSearch", value: searchText });
    }

    if (filterItems.length) {
      filterItems.forEach(({ name, value }) => {
        let newValue: string = "";

        if (isString(value)) {
          newValue = value;
        } else if (isDate(value)) {
          newValue = value.toISOString();
        } else {
          newValue = JSON.stringify(value);
        }

        body.parameters.push({ name, value: newValue });
      });
    }

    if (this.url.endsWith("/execute2") && maxResults !== "All") {
      body.parameters.push({ name: "CayoWebMaxResults", value: maxResults });
    }

    let items = await getClient(this.url, "POST", undefined, body, undefined, {
      fragment: "",
      signal: props?.signal,
    });

    if (query.orderBy?.field) {
      items = arrayUtils.sortByMultipleProperties(items, [
        query.orderBy.field,
        query.orderBy.direction === "ascending" ? "asc" : "desc",
      ]);
    }

    return { items, skipToken: null };
  }
}
